<template>
  <v-container fluid style="background: linear-gradient(#1A454A, #CBD3D4)">
    <!-- DESKTOP -->
    <div class="d-none d-lg-block">
      <v-row class="mx-16 px-16 align-start">
        <!-- ESQUERDA: ambos os textos -->
        <v-col cols="12" md="7" class="ma-0 py-12">
          <div class="text-accent text-uppercase text-h3 font-weight-black">
            {{ $t('team.passion') }}
          </div>
          <div class="text-accent text-uppercase text-h3 font-weight-black mt-12">
            {{ $t('team.offers') }}
          </div>
        </v-col>

        <!-- DIREITA: setas -->
        <v-col cols="12" md="5" class="d-flex justify-end">
          <v-img
            src="@/assets/covers/setas.svg"
            width="40%"
            class="mt-16 mr-8"
            style="position: relative;"
          />
        </v-col>
      </v-row>
    </div>

    <!-- MOBILE (já está OK: paixão → imagem → ofertas) -->
    <v-row justify="center" class="d-lg-none py-16 ma-0 pa-0 text-center">
      <v-col cols="12" class="ma-0 pa-0">
        <span class="text-accent text-uppercase text-h6 font-weight-black">
          {{ $t('team.passion') }}
        </span>
      </v-col>

      <v-col cols="6">
        <v-img src="@/assets/covers/setas.svg" :cover="false" class="mt-8" />
      </v-col>

      <v-col cols="12" class="mt-8">
        <span class="text-accent text-uppercase text-h6 font-weight-black">
          {{ $t('team.offers') }}
        </span>
      </v-col>
    </v-row>
  </v-container>
</template>


<script setup>
// nada a declarar — usa-se $t global do vue-i18n
</script>
